import { z } from 'zod';
import { FEEDBACK_FIELD_LIMITS } from './constants';

/**
 * Feedback form schema
 * Zod validation for the feedback form, mirroring the backend schema.
 * Last Updated Date: July 16, 2026
 * @author Jette
 */
export const feedbackSchema = z.object({
  category_id: z
    .number({ required_error: 'Please choose a category' })
    .int()
    .positive('Please choose a category'),
  description: z
    .string()
    .trim()
    .min(FEEDBACK_FIELD_LIMITS.descriptionMin, 'Please describe your feedback')
    .max(FEEDBACK_FIELD_LIMITS.descriptionMax, 'Feedback must be 2000 characters or less'),
});

export type FeedbackFormData = z.infer<typeof feedbackSchema>;
